export default function isAPIError(error: any): boolean {
  return !(error instanceof Error);
}
